// src/components/common/EmptyState.tsx
// 統一的空狀態顯示組件，取代各頁面的內聯實作

import React from 'react';
import { Plus } from 'lucide-react';

interface EmptyStateAction {
  label: string;
  onClick: () => void;
  /** Onboarding lesson anchor（可選） */
  'data-lesson-anchor'?: string;
}

interface EmptyStateProps {
  /** Lucide icon 組件（必填） */
  icon: React.ComponentType<{ size?: number | string; className?: string }>;
  /** 主標題（必填） */
  title: string;
  /** 副標題或說明（可選） */
  description?: string;
  /** CTA 按鈕（可選） */
  action?: EmptyStateAction;
  /** 外層容器的附加 className（預設 h-60，傳入時完整取代預設高度） */
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  action,
  className = '',
}) => (
  <div className={`flex flex-col items-center justify-center ${className || 'h-60'}`}>
    <Icon size={48} className="text-gray-400 mb-3" />
    <p className="text-gray-400 font-medium">{title}</p>
    {description && (
      <p className="text-sm text-gray-400 mt-1">{description}</p>
    )}
    {action && (
      <button
        onClick={action.onClick}
        data-lesson-anchor={action['data-lesson-anchor']}
        className="btn-accent btn-sm rounded-full mt-4"
      >
        <Plus size={16} />
        {action.label}
      </button>
    )}
  </div>
);

export default EmptyState;
